
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gKsVj0wUktvu8VLJ_h15bCzZf9wX9wUeOnujEVPWpF_45IMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexfLKCAv8vcCEmWsAquclsJIbKzaGuNzrz_2Mne4IGUnUMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchNyUmiegwPVyogP6vasGKsI1332ImVKCQVOBarPGly_sMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexRLGP1OCIIQ7kv4A5d_nHHcSNyls9LeqjVHF0lVzwhFwMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93WmsKWLyCdhYc_45QXGe_45FfmGvZ0a8G01KhPuIHtZZ1jZkMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexeuV7fhBrZ18077_ycobTHXPbDQ5_M3rgZ4Cd8w_3RI8Meta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_931n_45A_45F9ImjgBeN0qeSL_YML8ini0spSeXv1OJ11QqEUMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexQCfgfHKLr6oKTRkAKRj0YqtnCmYqN_45mL1Jk16TpnU1sMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93iD5plwaQIdzBsniZLXdXnPb_45ApPHjkGLxOxag9oWpLkMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexL_cmhjoENQxJ5W4uhZBfut8rys3EImyrdz0EOE_YWGQMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexI2B0KOBzHzxXIB4z_45PdJg4Ba89ZCR6NgaipBy3QoLZwMeta } from "/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexeuV7fhBrZ18077_ycobTHXPbDQ5_M3rgZ4Cd8w_3RI8Meta || {},
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexQCfgfHKLr6oKTRkAKRj0YqtnCmYqN_45mL1Jk16TpnU1sMeta || {},
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexL_cmhjoENQxJ5W4uhZBfut8rys3EImyrdz0EOE_YWGQMeta || {},
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexI2B0KOBzHzxXIB4z_45PdJg4Ba89ZCR6NgaipBy3QoLZwMeta || {},
    component: () => import("/codebuild/output/src3961125223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]